import "@fancyapps/fancybox";
import "instant.page/instantpage";
require("./vendors/jquery.sticky");
require("./vendors/jsurl");
require("./vendors/lazyframe");
require("./vendors/modernizr");
require("./vendors/theme-addresses.min");
require("./vendors/lite_youtube");
